import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../store/auth-context';
import LoginStyle from '../../Styles/Login.module.css';
import ButtonStyle from '../../Styles/Button.module.css';
import { FaCheck } from "react-icons/fa6";
import { SignUpRegisterSubmit, RegisterOTPVerifySubmit } from '../../../services/routes.services';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
const SignUpScreen = ({onClose, setForgotMsg}) => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    session_id: '',
  });
  const [errors, setErrors] = useState({});
  const [errorMsg, setErrorMsg] = useState('');

  const [step, setStep] = useState('form');
  const [regOtp, setRegOtp]= useState('');
  const [requestMsg, setRequestMsg] = useState();
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  // Handle input changes
  const changeHandler = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Validation handler for the form
  const validationHandler = () => {
    const newError = {};
    if (!formData.name.trim()) newError.name = "Name is required";
    if (!formData.email.trim()) {
      newError.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newError.email = 'Invalid email format';
    }
    if (!/^\d{10}$/.test(formData.mobile.trim())) {
      newError.mobile = "Valid 10-digit mobile number required";
    }
    return newError;
  };

  // Register Handler (Sign Up)
  const registerHandler = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    const validationError = validationHandler();
    if (Object.keys(validationError).length) {
      setErrors(validationError);
      return;
    }
    const postData = {
      u_name: formData.name,
      u_email: formData.email,
      u_phone: `+91${formData.mobile}`,
      session: formData.session_id,
    };
    try {
      const response = await SignUpRegisterSubmit(postData);
      const resData = response.data;
      if (resData.status === false || resData.message === "Phone already register, try login") {
        setRequestMsg(resData.message);
        return; 
      }
      setFormData((prev) => ({ ...prev, session_id: response.data.session_id }));

      console.log('Signup Success:', response.data);
      
      setStep('otp');
    } catch (error) {
      console.error('Signup error:', error.response?.data || error.message);
      setErrorMsg(error.response?.data?.message || 'Something went wrong');
    }
  };

  const registerOTPHandler = async ()=>{
    if(!regOtp){
      setErrorMsg('Please enter the OTP');
      return
    }
    const postData = {
      u_phone: `+91${formData.mobile}`,
      otp: regOtp,
      session: formData.session_id,
    }
    try{
      const response = await RegisterOTPVerifySubmit(postData);
      console.log('OTP Verifie:', response.data);
      if(response.data.message === "Login successful.") {
        const userData = {
          token: response.data.token,
          u_msg: response.data.message,
          u_email: response.data.user.u_email,
          u_number: response.data.user.u_phone,
          u_name: response.data.user.u_name,
        }

         authCtx.login(userData);
        navigate('/searchResult');
        onClose();        
        toast.success(response.data.message);
      }
    }catch (error) {
      setErrorMsg(error.response?.data?.message || 'OTP verification failed');
      console.error(error);
    }
  }
  return (

        <>
        {errorMsg && <span>{errorMsg}</span>}
        {step === 'form' ? 
        <>
        <h4>Welcome</h4>
        <p>Enter your details to sign up</p>
          {requestMsg && <span className={LoginStyle.successMsg}>Phone already register, try <button onClick={() => setForgotMsg(false)}>Login</button></span>}
            <div className={LoginStyle.inputFeild}>
            <input type="text" placeholder="Name" name="name" value={formData.name} onChange={changeHandler} />
            {errors.email && <span className={LoginStyle.errorMsg}>{errors.name}</span>}
            </div>
            <div className={LoginStyle.inputFeild + " " + LoginStyle.num}>
            <span>+91</span>
            <input type="number" placeholder="Mobile Number" name="mobile" value={formData.mobile} onChange={changeHandler} />
            {errors.email && <div className={LoginStyle.errorMsg}>{errors.mobile}</div>}
            </div>
            <div className={LoginStyle.inputFeild}>
            <input type="text" placeholder="Email" name="email" value={formData.email} onChange={changeHandler} />
            {errors.email && <span className={LoginStyle.errorMsg}>{errors.email}</span>}
            </div>
            <button onClick={registerHandler} className={`${ButtonStyle.largeButton} ${ButtonStyle.roundStyle} ${ButtonStyle.orangeStyle}`}>Get OTP</button>
            <a onClick={() => setForgotMsg(false)} title="Already registered">Already registered</a>
            </>
          :
          <div className={LoginStyle.regOtp}>
        
                <h4>Enter OTP</h4>
                <div className={LoginStyle.inputFeild}>
                  <input type="text" placeholder="OTP" value={regOtp} onChange={(e) => setRegOtp(e.target.value)}/>
                  {errorMsg && <div className={LoginStyle.errorMsg}>{errorMsg}</div>}
                </div>
                <input type="hidden" value={formData.mobile} name="u_phone" />
                <input type="hidden" value={formData.session_id} name="session" />
                <button onClick={registerOTPHandler} className={`${ButtonStyle.largeButton} ${ButtonStyle.roundStyle} ${ButtonStyle.orangeStyle}`}>Verify OTP</button>
            
          </div>
        }
              <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
    </>
    
  );
};

export default SignUpScreen;